import { cn } from "@design-system/utils";
import * as React from "react";

import { Skeleton } from "../skeleton";

function PropertyList({ className, ...props }: React.ComponentProps<"dl">) {
  return (
    <dl
      data-slot="property-list"
      className={cn("flex flex-col gap-4", className)}
      {...props}
    />
  );
}

function PropertyListItem({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="property-list-item"
      className={cn("flex flex-col gap-1", className)}
      {...props}
    />
  );
}

function PropertyListItemLabel({
  className,
  ...props
}: React.ComponentProps<"dt">) {
  return (
    <dt
      data-slot="property-list-item-label"
      className={cn("text-foreground-neutral-muted text-sm", className)}
      {...props}
    />
  );
}

function PropertyListItemValue({
  className,
  ...props
}: React.ComponentProps<"dd">) {
  return (
    <dd
      data-slot="property-list-item-value"
      className={cn(
        "text-foreground-neutral-default flex flex-col items-start text-base",
        className
      )}
      {...props}
    />
  );
}

function PropertyListSkeleton({
  count = 5,
  ...props
}: Omit<React.ComponentProps<"dl">, "children"> & { count?: number }) {
  return (
    <PropertyList data-slot="property-list-skeleton" aria-hidden {...props}>
      {Array.from({ length: count }).map((_, index) => (
        <PropertyListItem key={index}>
          <PropertyListItemLabel>
            <Skeleton className="h-5 w-24" />
          </PropertyListItemLabel>
          <PropertyListItemValue>
            <Skeleton className="h-6 w-56" />
          </PropertyListItemValue>
        </PropertyListItem>
      ))}
    </PropertyList>
  );
}

export {
  PropertyList,
  PropertyListItem,
  PropertyListItemLabel,
  PropertyListItemValue,
  PropertyListSkeleton,
};
